import { CaseClientContact } from 'src/app/shared/models/cases/caseClientContact';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { CaseClient } from '../models/cases/caseClient';
import { NgSelectProps } from '../models/ng-select-props';
import { ClientLite } from '../models/clients/client';
import { SearchParams } from '../models/searchParams';

@Component({
  selector: 'app-create-edit-file-client',
  templateUrl: './create-edit-file-client.component.html',
  styleUrls: ['./create-edit-file-client.component.scss']
})
export class CreateEditFileClientComponent implements OnInit {

  client: CaseClient;
  modalRef: NgbModalRef;

  clientNgSelect: NgSelectProps = null;
  descriptionNgSelect: NgSelectProps = null;
  contactNgSelect: NgSelectProps = null;

  @Output() submitClient: EventEmitter<CaseClient> = new EventEmitter();
  @ViewChild('clientModal') clientModal;

  contacts: CaseClientContact[] = [];

  constructor(
    private clientsApi: ClientsApiService,
    private modalService: NgbModal,
    private filesApi: FilesApiService,

  ) { }

  ngOnInit(): void {
    this.clientNgSelect = new NgSelectProps(this.clientsApi.getClientTiny);
    this.descriptionNgSelect = new NgSelectProps(this.filesApi.getDescriptions);
    this.contactNgSelect = new NgSelectProps(this.clientsApi.getClientContacts, new SearchParams());

  }
  open(client: CaseClient) {
    this.client = Object.assign(new CaseClient(), client);
    this.contacts = this.client.contacts.map(c => Object.assign(new CaseClientContact(), c));
    if (this.client.id) {
      this.contactNgSelect.params = [this.client.client.id];
    }
    this.modalRef = this.modalService.open(this.clientModal, {
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }

  onSubmit() {
    this.client.clientId = this.client.client.id;
    this.client.descriptionId = this.client.description.id;
    this.client.contacts = this.contacts.map(c => {
      c.contactId = c.contact.id;
      return c;
    });
    this.submitClient.emit(this.client);
    this.modalRef.close();
  }

  addContact() {
    this.contacts.push(new CaseClientContact());
  }

  removeContact(contact: CaseClientContact) {
    this.contacts = this.contacts.filter(l => l !== contact);
  }

  changeClient(client: ClientLite) {
    this.contactNgSelect.params = [client.id];
    this.contactNgSelect.loadItems();
  }

  searchFn() {
    return true;
  }

}
